import { Menu } from 'antd';
import React from 'react';
import './DropdownMenuStyles.less';

interface IDropdownMenuProps {
  keys: string[];
  selectedKey: string | undefined;
  onClick: (data: string) => void;
}

const DropdownMenu = ({ keys, selectedKey, onClick }: IDropdownMenuProps) => {
  return (
    <Menu className="account-dropdown-menu " selectedKeys={selectedKey ? [selectedKey] : []}>
      {keys.length ? (
        keys.map((key) => (
          <Menu.Item className="menu-item" key={key} onClick={() => onClick(key)}>
            {key}
          </Menu.Item>
        ))
      ) : (
        <Menu.Item className="menu-item" key={0} disabled>
          <em>Nothing to show</em>
        </Menu.Item>
      )}
    </Menu>
  );
};

interface IItemType {
  key: React.Key;
  title: string;
  icon?: string;
}
interface IDropdownWithIconMenuProps {
  items: IItemType[];
  selectedKey: string | undefined;
  onClick: (data: string) => void;
}

export const DropdownMenuWithIcon = ({
  items,
  selectedKey,
  onClick,
}: IDropdownWithIconMenuProps) => {
  return (
    <Menu className="account-dropdown-menu menu-with-icon" selectedKeys={selectedKey ? [selectedKey] : []}>
      {items.length ? (
        items.map(({key, title, icon}) => (
          <Menu.Item className="menu-item" key={key} onClick={() => onClick(title)}>
            {icon && <img src={icon} alt='' className='mr-1 icon-hw'/>}
            {title}
          </Menu.Item>
        ))
      ) : (
        <Menu.Item className="menu-item" key={0} disabled>
          <em>Nothing to show</em>
        </Menu.Item>
      )}
    </Menu>
  );
};

export default DropdownMenu;
